module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/SupplierTicket/SupplierTicket-list/SupplierTicket-list.component.css
// module id = ./src/app/SupplierTicket/SupplierTicket-list/SupplierTicket-list.component.css
// module chunks = main